import { defineModelEffect } from '@/app/libs/I';
import {
  globalModel,
} from '@/app/modules/global/globalModel';
import { bitrixEmailChange } from '@/shared/store/bitrixEmailChange';
import { get } from 'lodash-es';

const globals = {
  bitrixEmailChange,
};

/**
 * @deprecated legacy
 */
export const globalGet = defineModelEffect(globalModel, model => {
  return get(globals, model.path, null);
});
